import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, ArrowRight, CheckCircle, InfoCircle } from "@opendate-app/setlist";
import "./seriesChangeList.css";

const TONE_ICONS = { info: InfoCircle, warning: AlertCircle, error: AlertCircle, success: CheckCircle };

// Rows of "label   before -> after", with a group heading where the group
// changes. A screen reader hears "label changed from before to after".
export const SeriesChangeList = ({ rows }) => (
  <div className="series-change-list">
    {rows.map((row, index) => (
      <React.Fragment key={row.key}>
        {row.groupLabel && (index === 0 || rows[index - 1].groupLabel !== row.groupLabel) && (
          <div className="series-change-group">{row.groupLabel}</div>
        )}
        <div className="series-change-row" data-testid={`change-${row.key}`}>
          <span className="series-change-label">{row.label}</span>
          {row.note ? (
            <span className="series-change-note">{row.note}</span>
          ) : (
            <>
              {row.from ? <span className="sr-only"> changed from </span> : <span className="sr-only">: </span>}
              <span className={`series-change-from${row.from && row.from !== "—" ? " is-struck" : ""}`}>{row.from}</span>
              <ArrowRight size={16} className="series-change-arrow" aria-hidden="true" />
              {row.from && <span className="sr-only"> to </span>}
              <span className="series-change-to">{row.to}</span>
            </>
          )}
        </div>
      </React.Fragment>
    ))}
  </div>
);

SeriesChangeList.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.node,
    from: PropTypes.node,
    to: PropTypes.node,
    note: PropTypes.node,
    groupLabel: PropTypes.string,
  })).isRequired,
};

export const SeriesNote = ({ tone = "info", children }) => {
  const Icon = TONE_ICONS[tone] || InfoCircle;
  return (
    <div className={`series-note series-note-${tone}`}>
      <Icon size={16} className="series-note-icon" />
      <span>{children}</span>
    </div>
  );
};

SeriesNote.propTypes = {
  tone: PropTypes.oneOf(["info", "warning", "error", "success"]),
  children: PropTypes.node,
};
